import React from 'react';
import "./Spotify.css";
import CovidImg from "../assets/covidImg.png"

function Covid() {
  return (
    <div className="spotify">
       <h2>Covid-19 Tracker</h2>
       <img src={CovidImg}  alt="Amazon__image"/>
       <h3>Tech Stacks Used</h3>
       <div className='project__stacks'>
        <div className="project__stacksRow">
         <p className="project__stack">ReactJs</p>
         <p className="project__stack">Express</p>
         <p className="project__stack">Leaflet Map</p>
        </div>
        <div className='project__stacksRow'>
         <p className="project__stack">HTML</p>
         <p className="project__stack">CSS</p>
         <p className="project__stack">ChartJs</p>
        </div>
        <div className='project__stacksRow'>
        <p className="project__stack">JavaScript</p>
         <p className="project__stack">Material-Ui</p>
        </div>
       </div>
       <div className="project__links">
       <a className="project__link" href="https://covid-19-tracker-27e83.web.app/">Visit</a>
       <a  className="project__link" href="https://github.com/robinrdj/Covid-19-Tracker">Github repo</a>
       </div>
      
    </div>
  )
}

export default Covid;